module.exports = __webpack_public_path__ + "img/1.cbe5b3c3.webp";